function setupScrollCanvas(
  canvas,
  triggerElement,
  basePath,
  ext,
  frameCount,
  frameDuration,
  fadeTextId,
  contentPosition,
  externalController = null
) {
  const ctx = canvas.getContext("2d");
  const images = Array(frameCount);
  const loaded = Array(frameCount).fill(false);
  let loadedCount = 0;
  let currentFrame = 0;
  let initialized = false;
  let controller;
  let canvasWidth = 0;
  let canvasHeight = 0;

  const imgSrc = (n, padWidth = 5) =>
    `${basePath}${n.toString().padStart(padWidth, "0")}.${ext}`;

  function loadFrame(i) {
    const img = new Image();
    img.src = imgSrc(i);
    img.onload = () => {
      images[i] = img;
      loaded[i] = true;
      loadedCount++;
      if (i === 0 && !initialized) {
        initialized = true;
        resizeCanvas();
        render(0);
      }
    };
  }

  // 批量加载帧（跳过已加载）
  function preloadImages(prior = 8) {
    for (let i = 0; i < frameCount; i++) {
      if (loaded[i]) continue;
      if (i >= prior) setTimeout(() => loadFrame(i), 0);
      else loadFrame(i);
    }
  }

  function resizeCanvas() {
    const dpr = window.devicePixelRatio || 1;
    canvasWidth = canvas.clientWidth;
    canvasHeight = canvas.clientHeight;
    canvas.width = canvasWidth * dpr;
    canvas.height = canvasHeight * dpr;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpr, dpr);
  }

  // 渲染帧：等比缩放、居中绘制
  function render(index) {
    if (!loaded[index]) return;
    const img = images[index];

    ctx.clearRect(0, 0, canvasWidth, canvasHeight);

    const imgRatio = img.width / img.height;
    const canvasRatio = canvasWidth / canvasHeight;

    let drawWidth, drawHeight;
    if (imgRatio > canvasRatio) {
      drawWidth = canvasWidth;
      drawHeight = canvasWidth / imgRatio;
    } else {
      drawHeight = canvasHeight;
      drawWidth = canvasHeight * imgRatio;
    }

    const dx = (canvasWidth - drawWidth) / 2;
    const dy = (canvasHeight - drawHeight) / 2;

    ctx.drawImage(img, dx, dy, drawWidth, drawHeight);
  }

  function initScrollMagic() {
    // controller = new ScrollMagic.Controller();
    controller = externalController || new ScrollMagic.Controller();
    new ScrollMagic.Scene({
      triggerElement: triggerElement,
      duration: frameDuration,
      triggerHook: 0,
    })
      .setPin(triggerElement)
      .addTo(controller)
      .on("progress", (e) => {
        const frameIndex = Math.min(
          frameCount - 1,
          Math.floor(e.progress * frameCount)
        );
        if (frameIndex !== currentFrame && loaded[frameIndex]) {
          currentFrame = frameIndex;
          render(currentFrame);
        }

        // 文案渐入逻辑
        // 文案位置 top 的逻辑
        if (contentPosition === "top") {
          return
        }
        // 文案位置letf/right/bottom 的逻辑
        const fadeText = document.getElementById(fadeTextId);
        if (e.progress >= 0.4) {
          fadeText.classList.add("visible");
        } else {
          fadeText.classList.remove("visible");
        }
      });
  }

  function debounce(fn, delay = 100) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  const onResize = debounce(() => {
    resizeCanvas();
    render(currentFrame);
  });

  // 完整初始化逻辑（在视口内执行）
  function initialize() {
    window.addEventListener("resize", onResize);
    preloadImages(); // 加载剩余帧
    initScrollMagic(); // 绑定滚动控制
  }

  if (contentPosition === "top") {
    const fadeText = document.getElementById(fadeTextId);

    let started = false;
    let done = false;

    function updateFadeTextState() {
      if (done) return;

      const rect = fadeText.getBoundingClientRect();
      const triggerRect = triggerElement.getBoundingClientRect();

      // 文案开始淡入
      if (!started && rect.top < window.innerHeight) {
        fadeText.classList.add("visible"); // opacity 0 -> 1 via CSS
        started = true;
      }

      // 文案到达 trigger 顶部某个位置，比如 100px 以内
      if (started && Math.abs(rect.top - triggerRect.top) < 100) {
        // 结束淡入，确保动画完成
        fadeText.style.transition = "none"; // 停止动画
        fadeText.style.opacity = 1;
        done = true;
      }
    }

    // 监听滚动
    window.addEventListener("scroll", updateFadeTextState);
    // 初始触发一次
    updateFadeTextState();
  }

  // 元素进入视口后开始加载其余帧和绑定 scroll
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          obs.unobserve(entry.target);
          initialize();
        }
      });
    },
    { threshold: 0.1 }
  );

  observer.observe(triggerElement);

  // 提前显示首帧，避免白屏
  loadFrame(0);
}
